// src/pages/about/changelog/googleSheetsService.js

// URL Google Apps Script
export const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxVzbJCavNWEPd7QfMQLtzW4SlnM_yvsXC6Xnq1SD4NEQ5AMr-6YXcBwlOCVw1GCaI1vQ/exec';

// Fungsi untuk format timestamp
export const formatTimestamp = (timestamp) => {
    if (!timestamp) return '-';
    try {
        const date = new Date(timestamp);
        return date.toLocaleString('id-ID', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    } catch (e) {
        return timestamp;
    }
};

// Fungsi untuk menyimpan ke Google Sheets
export const saveToGoogleSheets = async (formData, user, action = 'ADD_CHANGELOG', id = null) => {
  try {
    // Data yang akan dikirim ke Google Sheets
    const dataToSend = {
      action: action,
      title: formData.title,
      category: formData.category,
      datetime: formData.datetime,
      status: formData.status,
      description: formData.description,
      user: user?.email || user?.displayName || 'Anonymous',
    };

    // Tambahkan ID jika mode edit
    if (id) {
      dataToSend.id = id;
    }

    console.log(`Sending data to Google Sheets (${action}):`, dataToSend);

    // Gunakan POST method dengan FormData untuk menghindari masalah URL length
    const formDataToSend = new FormData();
    Object.keys(dataToSend).forEach(key => {
      if (dataToSend[key] !== null && dataToSend[key] !== undefined) {
        formDataToSend.append(key, dataToSend[key]);
      }
    });
    
    console.log('Sending POST request...');
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'cors',
      body: formDataToSend,
    });
    
    console.log('POST response status:', response.status);
    
    if (response.ok) {
      const resultText = await response.text();
      console.log('POST response text:', resultText);
      
      let result;
      try {
        result = JSON.parse(resultText);
      } catch (parseError) {
        console.error('Failed to parse JSON:', parseError);
        // Coba ekstrak JSON dari HTML jika ada
        const jsonMatch = resultText.match(/\{.*\}/s);
        if (jsonMatch) {
          result = JSON.parse(jsonMatch[0]);
        } else {
          throw new Error('Response is not valid JSON: ' + resultText.substring(0, 200));
        }
      }
      
      console.log('POST response result:', result);
      
      if (result.success === false && result.message) {
        throw new Error(result.message);
      }
      
      return result;
    } else {
      const errorText = await response.text();
      console.error('POST error text:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText.substring(0, 100)}`);
    }
    
  } catch (error) {
    console.error('Error saving to Google Sheets:', error);
    throw error;
  }
};

// Fungsi untuk membaca data dari Google Sheets
export const fetchChangelogFromGoogleSheets = async () => {
  try {
    console.log('Fetching data from Google Sheets...');
    
    const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=GET_CHANGELOG`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    console.log('Fetch response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Fetch error:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Fetch result:', result);
    
    if (result.success) {
      return result.data.map(item => ({
        id: item.id || '',
        // Gunakan createdAt sebagai timestamp utama
        timestamp: item.createdAt || item.datetime || '',
        module: item.category || '',
        action: 'CREATE',
        description: item.description || '',
        user: item.user || '',
        details: item.title || '',
        title: item.title || '',
        category: item.category || '',
        status: item.status || '',
        createdAt: item.createdAt || '',
        datetime: item.datetime || '',
        rowNumber: item.rowNumber || '',
      }));
    } else {
      throw new Error(result.message || 'Gagal mengambil data');
    }
  } catch (error) {
    console.error('Error fetching from Google Sheets:', error);
    // Return array kosong jika error
    return [];
  }
};

// Fungsi untuk menghapus data
export const deleteFromGoogleSheets = async (id) => {
  try {
    console.log('Deleting data from Google Sheets, ID:', id);
    
    // Gunakan POST method untuk delete juga
    const formData = new FormData();
    formData.append('action', 'DELETE_CHANGELOG');
    formData.append('id', id);
    
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'cors',
      body: formData,
    });

    console.log('Delete response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Delete error:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const resultText = await response.text();
    console.log('Delete response text:', resultText);
    
    let result;
    try {
      result = JSON.parse(resultText);
    } catch (parseError) {
      console.error('Failed to parse JSON:', parseError);
      const jsonMatch = resultText.match(/\{.*\}/s);
      if (jsonMatch) {
        result = JSON.parse(jsonMatch[0]);
      } else {
        throw new Error('Response is not valid JSON: ' + resultText.substring(0, 200));
      }
    }
    
    console.log('Delete result:', result);
    
    return result;
    
  } catch (error) {
    console.error('Error deleting from Google Sheets:', error);
    throw error;
  }
};